'use client';

import type { ReactNode } from 'react';

export type BannerVariant = 'warning' | 'info';

export function Banner({
  variant = 'info',
  icon,
  title,
  children,
  actions,
  role = 'status',
  className,
}: {
  variant?: BannerVariant;
  icon?: ReactNode;
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  role?: 'status' | 'alert';
  className?: string;
}) {
  return (
    <div className={`mx-banner mx-banner--${variant}${className ? ` ${className}` : ''}`} role={role}>
      {icon && <div style={{ flex: 'none' }}>{icon}</div>}
      <div style={{ flex: 1, minWidth: 0 }}>
        {title != null && <p className="mx-banner__title">{title}</p>}
        {children != null && <p className="mx-banner__text">{children}</p>}
        {actions && <div style={{ marginTop: 8, display: 'flex', gap: 8 }}>{actions}</div>}
      </div>
    </div>
  );
}
